import { render, staticRenderFns } from "./virusRecord.vue?vue&type=template&id=77ab3592&scoped=true&"
import script from "./virusRecord.vue?vue&type=script&lang=js&"
export * from "./virusRecord.vue?vue&type=script&lang=js&"
import style0 from "./virusRecord.vue?vue&type=style&index=0&id=77ab3592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ab3592",
  null
  
)

export default component.exports